var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PanelLayout',{attrs:{"title":_vm.title},on:{"close":function($event){return _vm.$emit('close')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }